/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-11 16:35:29
 * @FilePath: \mrc-ess-fronted\src\util\mrc_base_init.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-30 18:09:52
 */
import Vue from "vue";
import _this from "../main.js";
var getBase = function (token, force = false) {
  if (!force && _this.$route && _this.$route.fullPath.indexOf("/login") != -1)
    return;
  if (token) {
    //获取时区
    _this
      .$Request({
        method: "POST",
        table: "ess_site",
        url: "/other/get-timeZone/",
        data: { is_default: 0 },
        global: true,
        type: null,
        notAlert: true,
      })
      .then((res) => {
        var arr = [];
        res.data.forEach(function (item, index) {
          arr.push({
            text: item.name,
            uuid: item.uuid,
            utc: item.utc_time_zone,
          });
          if (index == res.data.length - 1) {
            _this.$store.dispatch("setZone", arr);
          }
        });
      })
      .catch((err) => {});
    //获取默认时区
    _this
      .$Request({
        method: "POST",
        table: "ess_site",
        url: "/other/get-timeZone/",
        data: { is_default: 1 },
        global: true,
        type: null,
        notAlert: true,
      })
      .then((res) => {
        _this.$store.dispatch("setDefaultUTC", res.data["utc_time_zone"]);
      })
      .catch((err) => {});
    //颜色color
    _this
      .$findPrompt(
        {
          prompt_name: "ess_color_select",
        },
        true,
        null,
        true
      )
      .then((res) => {
        let Colors = [];
        res.data.map((item) => {
          Colors.push({
            text: item.view_fields,
            color: item.value_field,
          });
        });
        Vue.prototype.$Colors = Colors;
        // .sort(() => Math.random() - 0.5);
      })
      .catch((err) => {});
    //排版格子颜色参照
    _this
      .$findPrompt(
        {
          prompt_name: "ess_attendance_status_select",
        },
        true,
        null,
        true
      )
      .then((res) => {
        Vue.prototype.$card_line_colors = res.data;
      })
      .catch((err) => {});
    //查询客户参数2022-03-09 BJ
    _this
      .$Request({
        method: "POST",
        table: "mrbase_sys_client_param",
        url: "/other/get-client-param/",
        data: { param_name: "leave_balance_mode" },
        global: true,
        type: "client",
        notAlert: true,
      })
      .then((res) => {
        var mode = res.data;
        switch (typeof mode) {
          case "object":
            mode == 1;
            break;
          case "string":
            mode = res.data === "2" ? 2 : 1;
            break;
          default:
            mode = 1;
            break;
        }
        _this.$store.dispatch("setClientMode", mode);
      })
      .catch((err) => {});
  }
};
if (_this !== undefined && _this.$store.getters.userToken) {
  getBase(_this.$store.getters.userToken);
}
export default getBase;
